import script from "./SupportField.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportField.vue?vue&type=script&setup=true&lang=js"

import "./SupportField.vue?vue&type=style&index=0&id=622f88d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622f88d9"]])

export default __exports__